import React from "react";
import OrCinemaPromotion from "../../../components/OrCinemaPromotion";

const CinemaPromotion = props => <OrCinemaPromotion {...props} />;

export default CinemaPromotion;
